/**************************************************
 * Nombre:       Checks
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Login from "../Login/Login";
import {BrowserRouter, Route, Routes} from "react-router";
import Check_Moto from "./Tipo_Checks/Check_Moto";

const Checks = ({logo, logoRedondo}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <BrowserRouter>

                <Routes>


                    <Route path={'/Login'} element={<Login logo={logo} logoRedondo={logoRedondo}/>}/>
                    <Route path={'*'} element={<Login logo={logo} logoRedondo={logoRedondo}/>}/>
                    <Route path={'/'} element={<Login logo={logo} logoRedondo={logoRedondo}/>}/>

                    <Route path={'/moto'} element={<Check_Moto/>}/>


                </Routes>

            </BrowserRouter>


        </Grid>
    )

}
export default Checks